import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  container: {
    width: '100%',
    display: 'flex',
    padding: '0.5rem',
    flexDirection: 'column',
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
    },
  },
  filtersBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    [theme.breakpoints.down('lg')]: {
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
      paddingBottom: '1rem',
    },
    [theme.breakpoints.up('lg')]: {
      borderBottom: 'none',
      width: '400px',
      borderRight: '1px solid rgba(0, 0, 0, 0.12)',
      paddingRight: '1rem',
    },
  },
  barChartsContainer: {
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      width: 'calc(100% - 400px)',
      paddingLeft: '1rem',
    },
    [theme.breakpoints.down('lg')]: {
      paddingTop: '1rem',
    },
  },
  checkbox: {
    '& .MuiTypography-root': {
      width: '100%',
    },
  },
}))
